export var SPECS;
(function (SPECS) {
    SPECS["USE_LIGHTBOXES"] = "specs.stores.UseLightboxes";
    SPECS["ShouldUseOnlyBaseUrlAsOrigin"] = "specs.stores.ShouldUseOnlyBaseUrlAsOrigin";
    SPECS["ShouldUseOnlyPlatformExperiments"] = "specs.stores.ShouldUseOnlyPlatformExperiments";
    SPECS["IncreaseGqlGetLimit"] = "specs.stores.increaseGqlGetLimit";
    SPECS["AddProjectionsTYPQuery"] = "specs.ecom.AddProjectionsTYPQuery";
    SPECS["AlwaysSendCurrencyHeader"] = "specs.ecom.AlwaysSendCurrencyHeader";
    SPECS["StopSendingOriginInCheckoutUrl"] = "specs.ecom.StopSendingOriginInCheckoutUrl";
    SPECS["CallCartV2FromCartComponents"] = "specs.ecom.CallCartV2FromCartComponents";
    SPECS["OnlineStoresSessionStorageWithTTL"] = "specs.stores.OnlineStoresSessionStorageWithTTL";
    SPECS["ShowCheckoutOnEditorPreview"] = "specs.ecom.ShowCheckoutOnEditorPreview";
    SPECS["EcomPlatformWidgetsBFCache"] = "specs.ecom.EcomPlatformWidgetsBFCache";
    SPECS["MoveCustomUrlApiToSiteStoreConstructor"] = "specs.stores.MoveCustomUrlApiToSiteStoreConstructor";
})(SPECS || (SPECS = {}));
export var BI_STOREFRONT_VIEW_MODE;
(function (BI_STOREFRONT_VIEW_MODE) {
    BI_STOREFRONT_VIEW_MODE["SITE"] = "site";
    BI_STOREFRONT_VIEW_MODE["PREVIEW"] = "preview";
    BI_STOREFRONT_VIEW_MODE["EDITOR"] = "editor";
})(BI_STOREFRONT_VIEW_MODE || (BI_STOREFRONT_VIEW_MODE = {}));
export var BI_PRODUCT_OPTION_TYPE;
(function (BI_PRODUCT_OPTION_TYPE) {
    BI_PRODUCT_OPTION_TYPE["COLOR"] = "color";
    BI_PRODUCT_OPTION_TYPE["LIST"] = "list";
})(BI_PRODUCT_OPTION_TYPE || (BI_PRODUCT_OPTION_TYPE = {}));
export var BI_PRODUCT_OPTION_ACTION;
(function (BI_PRODUCT_OPTION_ACTION) {
    BI_PRODUCT_OPTION_ACTION["CHECKED"] = "checked";
    BI_PRODUCT_OPTION_ACTION["UNCHECKED"] = "unchecked";
})(BI_PRODUCT_OPTION_ACTION || (BI_PRODUCT_OPTION_ACTION = {}));
export var ONE_HUNDRED_THOUSAND = 100000;
export var VIEW_MORE_OPTIONS_URL_FRAGMENT = 'view-more-options';
export var SecondaryEvents = {
    GetRequest: 'CurrentCart.GetRequest',
    GetGQLRequest: 'CurrentCart.GetGQLRequest',
    GetV1Request: 'CurrentCart.GetV1Request',
    RefreshV1Request: 'CurrentCart.RefreshV1Request',
    UpdateLineItemsInCurrentCartRequest: 'CurrentCart.UpdateLineItemsInCurrentCartRequest',
    UpdateQuantityV1Request: 'CurrentCart.UpdateQuantityV1Request',
    RemoveLineItemsFromCurrentCartRequest: 'CurrentCart.RemoveLineItemsFromCurrentCartRequest',
    RemoveItemV1Request: 'CurrentCart.RemoveItemV1Request',
    UpdateBuyerNoteV1Request: 'CurrentCart.UpdateBuyerNoteV1Request',
    OnLoginStartRequest: 'CurrentCart.OnLoginStartRequest',
    OnLoginFinishRequest: 'CurrentCart.OnLoginFinishRequest',
    AddCouponToCurrentCartRequest: 'CurrentCart.AddCouponToCurrentCartRequest',
    ApplyCouponV1Request: 'CurrentCart.ApplyCouponV1Request',
    RemoveCouponFromCurrentCartRequest: 'CurrentCart.RemoveCouponFromCurrentCartRequest',
    RemoveCouponV1Request: 'CurrentCart.RemoveCouponV1Request',
    SetAddressV1Request: 'CurrentCart.SetAddressV1Request',
    SetDeliveryMethodForCurrentCartRequest: 'CurrentCart.SetDeliveryMethodForCurrentCartRequest',
    RemoveDeliveryMethodFromCurrentCartRequest: 'CurrentCart.RemoveDeliveryMethodFromCurrentCartRequest',
    SelectShippingOptionV1Request: 'CurrentCart.SelectShippingOptionV1Request',
    AddLineItemsToCurrentCart: 'CurrentCart.AddLineItemsToCurrentCart',
    AddToCurrentCartV1: 'CurrentCart.AddToCurrentCartV1',
    UpdateCurrentCartRequest: 'CurrentCart.UpdateCurrentCartRequest',
    RefreshCurrentCartRequest: 'CurrentCart.RefreshCurrentCartRequest',
    ActionResponse: 'CurrentCart.ActionResponse',
    CalculateCurrentCart: 'CurrentCart.CalculateCurrentCart',
    EstimateCurrentCart: 'CurrentCart.EstimateCurrentCart',
    EstimateCurrentCartTotalsV1: 'CurrentCart.EstimateCurrentCartTotalsV1',
    RemoveGiftCardFromCurrentCartRequest: 'CurrentCart.RemoveGiftCardFromCurrentCartRequest',
    AddGiftCardToCurrentCartRequest: 'CurrentCart.AddGiftCardToCurrentCartRequest',
    UpdateFormSubmissionsInCurrentCartRequest: 'CurrentCart.UpdateFormSubmissionsInCurrentCartRequest',
    Updated: 'CurrentCart.Updated',
    CreateCheckoutV1Request: 'CurrentCart.CreateCheckoutV1Request',
    HEALTH_CHECK: 'CurrentCart.HEALTH_CHECK',
    ACK: 'CurrentCart.ACK',
};
export var MiniCartEvents = {
    LoadedWithoutData: 'Minicart.LoadedWithoutData',
    OnInitialData: 'Minicart.OnInitialData',
};
export var DEFAULT_CURRENCY_HEADER = 'DEFAULT';
var ONE_MINUTE = 60 * 1000;
export var CACHE_TTL_MS = 10 * ONE_MINUTE;
//# sourceMappingURL=constants.js.map